<template>
  <b-card no-body>
    <b-card-header class="py-2 sc-header">
      <strong>Sub Companies (उपकंपनी)</strong>
      <small class="ml-2">All corporations in the system. Caste coverage drives the Master Report filtering.</small>
    </b-card-header>
    <b-card-body>
      <div class="text-right mb-2" v-if="rows.length">
        <json-excel :data="excelRows" :name="'SubCompanies.xls'" class="d-inline-block">
          <b-button size="sm" variant="success"><i class="fa fa-file-excel"></i> Excel</b-button>
        </json-excel>
      </div>

      <b-table
        small
        bordered
        striped
        hover
        responsive
        head-variant="dark"
        :items="rows"
        :fields="fields"
        style="font-size: 13px"
      >
        <template v-slot:cell(type)="row">
          <b-badge :variant="row.item.isMain ? 'primary' : 'secondary'">{{ row.item.type }}</b-badge>
        </template>
        <template v-slot:cell(castes)="row">
          <span v-if="row.item.castesText">{{ row.item.castesText }}</span>
          <b-badge v-else variant="warning">Not configured</b-badge>
        </template>
        <template v-slot:cell(action)="row">
          <b-button size="sm" variant="info" class="py-0" @click="$emit('select', row.item.id)">
            Run Report
          </b-button>
        </template>
      </b-table>

      <small class="text-muted">
        To set which castes belong to each sub-company, edit
        <code>src/config/subCompanies.js</code>. Companies marked
        <b-badge variant="warning">Not configured</b-badge> filter by establishment date only.
      </small>
    </b-card-body>
  </b-card>
</template>

<script>
import { ALL_COMPANIES } from "@/config/subCompanies";
import Formatter from "@/Formatter";
import JsonExcel from "vue-json-excel";

export default {
  name: "SubCompanies",
  components: { JsonExcel },
  data() {
    return {
      fields: [
        { key: "sr", label: "#" },
        { key: "name", label: "Company Name" },
        { key: "shortName", label: "Short Name" },
        { key: "type", label: "Type" },
        { key: "estText", label: "Establishment / GR Date" },
        { key: "castes", label: "Castes Covered" },
        { key: "action", label: "Report" }
      ]
    };
  },
  computed: {
    rows() {
      return ALL_COMPANIES.map((c, i) => ({
        id: c.id,
        sr: i + 1,
        name: c.name,
        shortName: c.shortName,
        isMain: c.isMain === true,
        type: c.isMain ? "Main Company" : "Sub Company",
        estText: Formatter.convertDateFormat(c.est),
        castesText:
          c.castes && c.castes.length
            ? c.castes.join(", ")
            : c.isMain
            ? "All VJNT castes"
            : ""
      }));
    },
    excelRows() {
      return this.rows.map(r => ({
        "#": r.sr,
        "Company Name": r.name,
        "Short Name": r.shortName,
        Type: r.type,
        "Establishment / GR Date": r.estText,
        "Castes Covered": r.castesText || "Not configured"
      }));
    }
  }
};
</script>

<style scoped>
.sc-header {
  background-color: #0a0032;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminReports/SubCompanies.vue